import { Address, ShippingAddress } from "./Address";

export interface Cfdis {
    items: Cfdi[];
    total: number;
}

export interface Cfdi {
    id: string;
    serie?: string;
    folio?: string;
    fecha: Date;
    forma_pago: string;
    condiciones_pago?: string;
    subtotal?: number;
    descuento?: number;
    moneda?: string;
    tipo_cambio?: number;
    total: number;
    tipo_comprobante: string;
    metodo_pago: string;
    lugar_expedicion?: string;
    confirmacion?: string;
    sello?: string;
    numero_certificado?: string;
    certificado?: string;
    cfdis_relacionados?: CfdisRelacionados;
    emisor?: Emisor;
    receptor: Receptor;
    complementos?: Complementos;
    metadata?: CfdiMetadata;
}

export interface Emisor {
    rfc: string;
    nombre: string;
    regimen_fiscal: string;
}

export interface Receptor {
    rfc: string;
    nombre: string;
    residencia_fiscal?: string;
    numero_registro_id_tributario?: string;
    uso_cfdi?: string;
    metadata?: string;
}

export interface ReceptorMetadata {
    address?: Address;
}

export interface CfdisRelacionados {
    tipo_relacion: string;
    cfdis_relacionados: CfdiRelacionado[];
}

export interface CfdiRelacionado {
    uuid: string;
}

export interface Complementos {
    timbre_fiscal_digital?: TimbreFiscalDigital;
    pagos?: Pagos;
}

export interface TimbreFiscalDigital {
    version: string;
    uuid: string;
    fecha_timbrado: Date;
    rfc_proveedor_certificacion?: string;
    leyenda?: string;
    numero_certificado_sat?: string;
    sello_sat?: string;
}

export interface Pagos {
    version: string;
    pagos: Pago[];
}

export interface Pago {
    fecha_pago: Date;
    forma_pago: string;
}

export interface CfdiMetadata {
    tenant_id: string;
    customer_id: string;
    payment_id?: string;
    payment_status?: string;
    balance: number;
    xml_path: string;
    pdf_path: string;
    purchase_order?: string;
    sales_order?: string;
    credit?: Credit;
    shipping_address?: ShippingAddress;
    payment_amount?: number; // only UI
    due_date?: Date;
    type: 'I' | 'E' | 'ND' | 'NC' | 'T' | 'N' | 'P';
    cancel_in_process?: boolean;
}

export interface Credit {
    days?: number;
    expires?: string;
}

export interface CfdiQueryParams {
    search: string;
    type: string;
    payment_status?: string;
    from?: string;
    to?: string;
    ids?: string[];
}

export interface CfdisExportResponse {
    total: number;
    url?: string;
    expire?: Date;
}

export interface ReplacePaymentCfdiRequest {
    form: string;
    date: Date;
}

export interface CancelCfdiRequest {
    reason?: CancelReason
    substitute_uuid?: string
}

export const REGIME = ["601", "603", "605", "606", "608", "609", "610", "611", "612", "614", "616", "620", "621", "622", "623", "624", "628", "607", "629", "630", "615"];

export const TYPE = ["I", "E", "P", "T"];

export const PAYMENT_STATUS = ["pending", "waiting", "validating", "pending_cfdi", "cancelled", "completed"];

// export const PAYMENT_FORM = ["01", "02", "03", "04", "05", "06", "08", "12", "13", "14", "15", "17", "23", "24", "25", "26", "27", "28", "29", "99"];
export const PAYMENT_FORM = ["02", "03"];

export type CancelReason = "errores_con_relacion" | "errores_sin_relacion" | "no_concreta" | "factura_global";

export const CANCEL_REASONS: CancelReason[] = ["errores_con_relacion", "errores_sin_relacion", "no_concreta", "factura_global"];